module.exports = __webpack_public_path__ + "img/matriz-icon.b6158758.png";